import "./App.css";
import { AppRouter } from "./components/AppRouter/AppRouter";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider } from "./context/ConfigContext";
import { UIDProvider } from "./context/UIDContext";
import { FlowIDProvider } from "./context/FlowIDContext";
import { OpenCvProvider } from "opencv-react";
import { AmplitudeProvider } from "./context/AmplitudeContext";
import { ScanImageProvider } from "./context/ImageContext";
import "./theme.css";
import { APIProvider } from "@vis.gl/react-google-maps";

function App() {
  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <OpenCvProvider openCvPath="/libs/opencv.js">
          <APIProvider apiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
            <ConfigProvider>
              <UIDProvider>
                <FlowIDProvider>
                  <ScanImageProvider>
                    <AmplitudeProvider>
                      <AppRouter />
                    </AmplitudeProvider>
                  </ScanImageProvider>
                </FlowIDProvider>
              </UIDProvider>
            </ConfigProvider>
          </APIProvider>
        </OpenCvProvider>
      </I18nextProvider>
    </div>
  );
}

export default App;
